"use client";
import { useLocale } from "next-intl";
import Script from "next/script";
import React from "react";

export default function ConsentManager() {
  const locale = useLocale();
  return (
    <>
      <Script
        key={locale}
        id="Cookiebot"
        src="https://consent.cookiebot.com/uc.js"
        data-cbid="7d2013f7-5c94-4d88-b863-7db6864b31cf"
        data-culture={locale.toUpperCase()}
        type="text/javascript"
      />
    </>
  );
}
